module.exports = __webpack_public_path__ + "img/login-bg.66528f07.jpg";